import Alpine from 'alpinejs'
import ToastComponent from '../../vendor/usernotnull/tall-toasts/dist/js/tall-toasts'
import instance from './http/axios'
const dayjs = require('dayjs')
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isSameOrBefore)
Alpine.data('ToastComponent', ToastComponent)
window.Alpine = Alpine;
window.axios = instance
window.dayjs = dayjs
window.Alpine = Alpine
Alpine.start()

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
